import React from 'react';
import DetailsPortal from './DetailsPortal';
import './OrderDetailsPanel.css';

const DeviceDetailsPanel = ({ device, onClose, onEdit }) => {
  if (!device) return null;

  // Data is now on top level
  const deviceData = device;

  const formatValue = (value) => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'object') return JSON.stringify(value, null, 2);
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    return String(value);
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return '-';
    try {
      const date = new Date(timestamp * 1000);
      if (isNaN(date.getTime())) {
        const date2 = new Date(timestamp);
        if (isNaN(date2.getTime())) return String(timestamp);
        return formatCustomDate(date2);
      }
      return formatCustomDate(date);
    } catch {
      return String(timestamp);
    }
  };

  const formatCustomDate = (date) =>
    `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()} ${String(
      date.getHours()
    ).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;

  // Format Status the same way as in the table
  const getStatus = () => {
    const status = (deviceData.Status || deviceData.status || '').toLowerCase();
    return { status, text: deviceData.Status || deviceData.status || '-' };
  };

  const status = getStatus();
  const displayName = deviceData.userDeviceName || deviceData.UserDeviceName || deviceData.user_device_name || '-';
  const deviceName = deviceData.DeviceName || deviceData.deviceName || deviceData.device_name || '-';
  const deviceModel = deviceData.device_model || deviceData.deviceModel || deviceData.DeviceModel || '-';
  const deviceId = deviceData.device_id || deviceData.deviceId || deviceData.DeviceId || deviceData.ref || '-';
  const deviceImei = deviceData.device_imei || deviceData.deviceImei || deviceData.DeviceImei || '-';
  const traderId = deviceData.traderId || deviceData.TraderId || deviceData.TRADER_ID || '-';
  const created = formatDate(deviceData.Created || deviceData.created || device.create_time || deviceData.create_time);
  const changed = formatDate(deviceData.LastChanged || deviceData.lastChanged || device.change_time || deviceData.change_time);

  return (
    <DetailsPortal>
    <div className="order-details-overlay" onClick={onClose}>
      <div className="order-details-panel" onClick={(e) => e.stopPropagation()}>
        <div className="order-details-header">
          <h2>Device Details</h2>
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            {onEdit && (
              <button 
                className="edit-button"
                onClick={() => {
                  if (onEdit) {
                    onEdit(device);
                  }
                }}
              >
                Edit
              </button>
            )}
            <button type="button" className="close-button" onClick={onClose}>Close</button>
          </div>
        </div>
        <div className="order-details-content">
          <div className="order-summary">
            <div className="summary-main">
              <span className="summary-label">Device</span>
              <span className="summary-primary">{formatValue(displayName)}</span>
              <span className="summary-secondary">Device name: {formatValue(deviceName)}</span>
            </div>
            <div className="summary-chips">
              <span className={`status-badge status-${status.status}`}>{status.text}</span>
            </div>
          </div>

          <div className="detail-section">
            <h3>Details</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="detail-label">Device Label</span>
                <span className="detail-value">{formatValue(displayName)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Device Name</span>
                <span className="detail-value">{formatValue(deviceName)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Device Model</span>
                <span className="detail-value">{formatValue(deviceModel)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Device ID</span>
                <span className="detail-value">{formatValue(deviceId)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Device IMEI</span>
                <span className="detail-value">{formatValue(deviceImei)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Trader ID</span>
                <span className="detail-value">{formatValue(traderId)}</span>
              </div>
            </div>
          </div>

          <div className="detail-section">
            <h3>Timeline</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="detail-label">Created</span>
                <span className="detail-value">{created}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Last Changed</span>
                <span className="detail-value">{changed}</span>
              </div>
            </div>
          </div>

          <div className="detail-section">
            <h3>All Data</h3>
            <pre className="detail-json">
              {JSON.stringify(deviceData, null, 2)}
            </pre>
          </div>
        </div>
      </div>
    </div>
    </DetailsPortal>
  );
};

export default DeviceDetailsPanel;
